'use strict';

/**
 * @ngdoc function
 * @name pwrApp.controller:RewardsFAQCtrl
 * @description
 * # RewardsFAQCtrl
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'RewardsFAQCtrl',
    function (
      $scope,
      $rootScope,
      $location,
      crumble,
      $route,
      $routeParams,
      ENV,
      $sce,
      CmsService,
      $compile,
    ) {
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      }
      var slug = 'pro-rewards-resources';

      if (!$scope.isRewardsSubscribed) {
        $location.path('/find-a-pet');
      }

      $scope.isEmpty = function (obj) {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) return false;
        }
        return true;
      };

      CmsService.getCmsContent(slug).then(function (response) {
        if ($scope.isEmpty(response)) {
          $location.path('/find-a-pet');
        } else {
          $scope.dashboardTileTitle = response.title;
          $scope.dashboardTileSubtitle = response.subtitle;

          var $body = $(response.body);
          $body.find('a').each(function () {
            if ($(this).attr('href').indexOf(ENV.proURL) >= 0) {
              $(this).attr('target', '');
              var thisHref = $(this).attr('href').replace(ENV.proURL, '.');
              $(this).attr('ng-href', thisHref);
              $(this).attr('href', '#');
            }
            if ($(this).attr('href').indexOf('slug:') >= 0) {
              $(this).attr('target', '');
              var thisHref = $(this).attr('href').replace('slug:', '');
              $(this).attr('ng-click', "cmsPageLink('" + thisHref + "');");
              $(this).attr('href', '#');
            }
          });
          var temp = $compile($body)($scope);
          angular.element(document.getElementById('cms-page-content')).append(temp);
        }
      });
    },
  );
